module.exports = __webpack_public_path__ + "static/media/list.8bb33e35.svg";